/* eslint-disable react/no-danger */
// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Divider, Group, Stack, Text } from '@mantine/core';
import moment from 'moment';
import { FC, useContext } from 'react';
import { MailS } from '../../Service/MailS';
import { EmailBoxContext } from '../../Service/Context/EmailBoxContext';
import { MessageText } from '../../Atoms/MessagePlaceholderText';
import { ThemeText } from '../../Atoms/ThemeText';

const ReplyMessagePreview: FC<{ withPadding?: boolean }> = ({ withPadding = false }) => {
  const { selectedMessage } = useContext(EmailBoxContext);

  if (!selectedMessage) {
    return null;
  }
  return (
    <Group noWrap ml={withPadding ? 15 : 0} mb="lg" mt="sm">
      <Divider size="xl" orientation="vertical" sx={{ borderRadius: 10 }} />
      <Stack>
        <Text sx={(theme) => ({ color: theme.colorScheme === 'dark' ? 'orange' : theme.colors.blue[4] })}>
          Am {moment(selectedMessage.lastModified).format('D MMM YYYY, [um] HH:mm')}
          {' Uhr '}
          schrieb{'  '}
          <Text span weight="bolder">
            {MailS.getParticipantAddress(selectedMessage.from)}
          </Text>
          :{' '}
        </Text>
        <ThemeText>
          <MessageText htmlValue={selectedMessage.message} />
        </ThemeText>
      </Stack>
    </Group>
  );
};

export default ReplyMessagePreview;
